import { render } from "./ResearchCampaignWizard.vue?vue&type=template&id=e82008f0&scoped=true"
import script from "./ResearchCampaignWizard.vue?vue&type=script&lang=js"
export * from "./ResearchCampaignWizard.vue?vue&type=script&lang=js"

import "./ResearchCampaignWizard.vue?vue&type=style&index=0&id=e82008f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e82008f0"]])

export default __exports__